module.exports = __webpack_public_path__ + "img/widgetabout-1.38645ffa.jpg";